import {OrganizationListPage} from './OrganizationListPage'

export const OrganizationList = OrganizationListPage;